import { useRef } from 'react';
import Dialog from 'src/componentes/dialog';
import OnboardingContainer from './OnboardingContainer';

const OnboardingModal = ({ tipoAcessoSSO }) => {
  const ref = useRef();
  const handleFinish = () => {
    if (ref.current) {
      ref.current.close();
      window.location.reload();
    }
  };

  return (
    <Dialog
      ref={ref}
      showClose={false}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={() => {}}
      style={{
        width: '100vw',
        height: '95vh',
      }}
    >
      <OnboardingContainer onFinish={handleFinish} tipoAcessoSSO={tipoAcessoSSO} />
    </Dialog>
  );
};

export default OnboardingModal;
